import React, { Suspense, useRef } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, Sphere, Environment } from '@react-three/drei';
import * as THREE from 'three';
import { useSphereStore } from '../store/sphereStore';
import { UniversalUIPage } from './UniversalUIPage';

const pageStyle: React.CSSProperties = {
  display: 'flex',
  height: '100vh',
  width: '100vw',
  background: 'linear-gradient(180deg, #020617 0%, #0f172a 100%)',
};

const canvasContainerStyle: React.CSSProperties = {
  flex: '2',
  height: '100%',
};

const uiContainerStyle: React.CSSProperties = {
  flex: '1',
  height: '100%',
  overflowY: 'auto',
  padding: '1rem',
  background: 'rgba(15, 23, 42, 0.8)',
  backdropFilter: 'blur(10px)',
  borderLeft: '1px solid rgba(59, 130, 246, 0.3)',
};

function Scene() {
  const { scale, color, metalness, roughness, wireframe } = useSphereStore();

  return (
    <>
      <ambientLight intensity={0.5} />
      <directionalLight position={[10, 10, 5]} intensity={1.5} />
      <Sphere args={[1, 32, 32]} scale={scale}>
        <meshStandardMaterial 
          color={color} 
          metalness={metalness}
          roughness={roughness}
          wireframe={wireframe}
        />
      </Sphere>
      <OrbitControls />
      <Environment preset="city" />
    </>
  );
}

export function InteractiveSpherePage() {
  const meshRef = useRef<THREE.InstancedMesh>(null!);

  return (
    <div style={pageStyle}>
      <div style={canvasContainerStyle}>
        <Canvas camera={{ position: [0, 0, 5], fov: 75 }}>
          <Suspense fallback={null}>
            <Scene />
          </Suspense>
        </Canvas>
      </div>
      <div style={uiContainerStyle}>
        <UniversalUIPage yamlFile="sphere-config.yaml" store={useSphereStore as any} meshRef={meshRef} />
      </div>
    </div>
  );
} 